import React from "react";
import { Link } from "react-router-dom";
import img1 from "../assets/images/tiktok-brands-solid.svg";
import img2 from "../assets/images/x-twitter-brands.svg";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <>
      {/* <!-- Footer Start --> */}
      <footer className="footer-modern">
        <div className="container">
          <div className="footer-top">
            <div className="footer-brand">
              <span className="footer-eyebrow">Royal Mines Property</span>
              <h3>Trusted guidance for confident property decisions.</h3>
              <p>
                Plot 251/252 Herbert Macaulay way Millennium Plaza Central
                Business District Opposite NNPC Towers.
              </p>
              <div className="footer-contact">
                <a href="tel:+2349152415476">
                  <i className="fa fa-phone-alt"></i>
                  +234 915 241 5476
                </a>
                <span>
                  <i className="fa fa-envelope"></i>
                  info@royalminesproperty.com
                </span>
              </div>
            </div>

            <div className="footer-links">
              <div>
                <h5>Company</h5>
                <Link to="/about">About</Link>
                <Link to="/properties">Properties</Link>
                <Link to="/contact">Contact</Link>
              </div>
              <div>
                <h5>Resources</h5>
                <Link to="/frequently-asked-questions">FAQs</Link>
                <Link to="/contact#feedback">Feedback</Link>
                <Link to="/properties">Pricing</Link>
              </div>
            </div>

            <div className="footer-social">
              <h5>Social</h5>
              <div className="footer-social-links">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://x.com/Royalmines_?t=hgCSDivWiAunjfBiKA2LeA&s=09"
                >
                  <img src={img2} alt="x-twitter" width="20" height="20" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/share/1VGVnus83r/"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/Royalmines_Apartment/"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.tiktok.com/@royalmines.apartm?_t=ZM-8wAxEwleBpG&_r=1"
                >
                  <img src={img1} alt="tiktok" width="20" height="20" />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <span>&copy; {year} RoyalMines Property. All rights reserved.</span>
            <div className="footer-bottom-links">
              <Link to="/">Home</Link>
              <Link to="/frequently-asked-questions">FAQs</Link>
              <Link to="/contact">Support</Link>
            </div>
          </div>
        </div>
      </footer>
      {/* <!-- Footer End --> */}
    </>
  );
}

export default Footer;
